.pos-relative{min-height:auto}
/*# sourceMappingURL=detail-company.component-H35WBELL.css.map */
